export default "__VITE_ASSET__DJyvjAdu__"